import {HTMLAttributes} from 'react';
import {UrlLink} from '../../../applink/UrlLink';
import {twMerge} from '../../../common/twMerge';

export interface MenuTabListItem {
  name: string;
  param: string;
  href?: string;
}

export interface MenuTabListProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'onSelect'> {
  items: MenuTabListItem[];
  selectedTab: string;
  onSelect: (param: string) => void;
}

/**
 * 필터 메뉴 탭 목록 컴포넌트
 * 선택 가능한 탭 아이템들을 관리하며 선택 상태를 처리합니다.
 */
export function MenuTabList({
  items,
  selectedTab,
  onSelect,
  className,
  ...props
}: MenuTabListProps) {
  return (
    <div className={twMerge(['relative', className])} {...props}>
      <div className="overflow-x-auto scrollbar-hide">
        <div className="flex items-center gap-4pxr pr-40pxr">
          {items.map(item => {
            const isSelected = selectedTab === item.param;
            return (
              <UrlLink
                url={item.href}
                key={item.param}
                linkClassName={twMerge(
                  'flex shrink-0 items-center justify-center last:pr-20px'
                )}
                onClick={() => onSelect(item.param)}
              >
                <div
                  className={twMerge(
                    'flex h-32pxr items-center justify-center px-8pxr rounded-8pxr',
                    isSelected
                      ? 'bg-theme-solid-10 font-medium2-bold text-theme-solid-100'
                      : 'font-medium2 text-theme-solid-60'
                  )}
                >
                  {item.name}
                </div>
              </UrlLink>
            );
          })}
        </div>
      </div>
      <div className="absolute right-0 top-0 bottom-0 w-40pxr bg-gradient-to-l from-theme-solid-0 to-transparent pointer-events-none" />
    </div>
  );
}
